import { Component, HostListener, OnInit, AfterViewInit, OnDestroy, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { CampaignsService } from 'src/app/services/campaigns/campaigns.service';
import { Router } from '@angular/router';
import { getFirebaseBackend } from 'src/app/authUtils';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { AppComponent } from 'src/app/app.component';
import { UserService } from 'src/app/services/user/user.service';
import { ProspectsService } from 'src/app/services/prospects/prospects.service';
import { forkJoin } from 'rxjs';

@Component({
	selector: 'app-campaigns',
	templateUrl: './campaigns.component.html',
	styleUrls: ['./campaigns.component.scss'],
})
export class CampaignsComponent implements OnInit, AfterViewInit, OnDestroy {
	user: any = null;
	campaigns: any[] = [];
	searchCampaign: any[] = [];
	pagina: number = 0;
	todo: any[] = [];
	isLoading = false;

	@ViewChild(DatatableComponent) table!: DatatableComponent;
	@ViewChild(DatatableComponent, { read: ElementRef }) tableRef!: ElementRef;

	private resizeObserver?: ResizeObserver;

	columnas = [
		{ name: 'Name', prop: 'name' },
		{ name: 'Timezone', prop: 'timezone' },
		{ name: 'Records', prop: 'total_prospects' },
		{ name: 'Needed', prop: 'leads_needed' },
		{ name: 'Industry', prop: 'industry' },
		{ name: 'Types', prop: 'types' },
		{ name: 'CB', prop: 'cb' },
		{ name: ' ', prop: 'icons' },
	];
	userservice: any;

	constructor(
		private campaignsSrv: CampaignsService,
		private router: Router,
		private cdr: ChangeDetectorRef,
		private loaderSrv: LoaderService,
		private userSrv: UserService,
		private prospectsService: ProspectsService,
	) {
		this.user = getFirebaseBackend()?.getAuthenticatedUser();
	}

	ngOnInit() {
		this.loaderSrv.loading$.subscribe((loading) => {
			this.isLoading = loading;
		});
		this.getCampaigns(this.user.IdUser);
		this.userSrv.saveAction('Entry to campaigns');
	}

	ngAfterViewInit() {
		this.resizeObserver = new ResizeObserver(() => {
			// requestAnimationFrame evita el warning "ResizeObserver loop limit exceeded"
			requestAnimationFrame(() => {
				this.table?.recalculate();
				this.cdr.detectChanges();
			});
		});
		this.resizeObserver.observe(this.tableRef.nativeElement);
	}

	ngOnDestroy() {
		this.resizeObserver?.disconnect();
	}

	getCampaigns(userId: number) {
		this.loaderSrv.show();
		this.campaignsSrv.getCallerCampaigns(userId).subscribe({
			next: (res: any) => {
				this.todo = res?.body ?? res?.data ?? res ?? [];
				this.searchCampaign = [...this.todo];
				this.campaigns = [...this.searchCampaign];
				this.loadCallbacksCount().add(() => {
					this.loaderSrv.hide();
				});
			},
			error: (err) => {
				console.error('Error fetching campaigns:', err);
				this.loaderSrv.hide();
			},
		});
	}

	campaignSearch(event: any) {
		const valor = event.target.value.toLowerCase();
		this.searchCampaign = this.todo.filter((c) => c.name.toLowerCase().includes(valor));
		this.campaigns = [...this.searchCampaign];
	}

	getIcons(types: string | number): string[] {
		const typeList = types
			.toString()
			.split(',')
			.map((t) => t.trim());
		const icons: string[] = [];
		if (typeList.includes('1')) icons.push('ri-service-fill');
		if (typeList.includes('2')) icons.push('ri-phone-fill');
		if (typeList.includes('3')) icons.push('ri-macbook-fill');
		return icons;
	}

	openCalendar(id: number, alias: string) {
		this.userSrv.saveAction('Open Calendar');
		const url = `/#/calendar/${alias}/${id}?from=campaign`;
		window.open(url, '_blank', 'height=825,width=1200,scrollbars=yes,status=yes');
	}

	goToProspect(campaignId: string, alias: string) {
		this.prospectsService.clearCurrentProspect();
		this.loaderSrv.show();

		const user = getFirebaseBackend()?.getAuthenticatedUser();
		this.userSrv.saveCurrentCampaign(user?.IdUser, campaignId).subscribe({
			next: () => {
				this.router.navigate(['/prospect-info', campaignId, alias]).then(() => {
					this.loaderSrv.hide();
				});
			},
			error: (err) => {
				console.error('Error guardando campaña actual:', err);
				this.router.navigate(['/prospect-info', campaignId, alias]).then(() => {
					this.loaderSrv.hide();
				});
			},
		});
	}

	loadCallbacksCount() {
		const requests = this.campaigns.map((campaign) => this.campaignsSrv.getCallbacksCount(campaign.id, this.user.IdUser));

		return forkJoin(requests).subscribe({
			next: (responses: any[]) => {
				responses.forEach((res, index) => {
					const campaign = this.campaigns[index];
					campaign.total_callbacks = res.body?.total_callbacks ?? 0;
				});
			},
			error: (err) => {
				console.error('Error cargando conteo de callbacks:', err);
				this.campaigns.forEach((c) => (c.total_callbacks = 0));
			},
		});
	}

	openReschedules(campaign: any) {
		if (!campaign || !campaign.id) {
			console.error('⚠️ No se recibió la campaña correctamente:', campaign);
			return;
		}
		localStorage.setItem('selectedCampaignId', campaign.id);
		this.router.navigate(['/callback', campaign.id, campaign.alias || ''], { queryParams: { tab: 'reschedules' } });
	}

	goToReschedules(campaign: any) {
		if (!campaign || !campaign.id) {
			console.error('⚠️ No se recibió la campaña correctamente:', campaign);
			return;
		}
		this.router.navigate(['/reschedules'], { queryParams: { campaign_id: campaign.id } });
	}
}
